<template>
  <div class="banner cl">
    <div class="swiper-container" id="s1" v-if="BnnerSlides.length > 0">
      　
      <div class="swiper-wrapper">
        <div
          class="swiper-slide"
          v-for="(item, index) in BnnerSlides"
          :key="index"
        >
          <div class="img_warp" :style="{ backgroundColor: item.bg_color }">
            <!-- <img class="bg bannrImgAnimation" :src="Pcbg(item)" alt="" /> -->

            <div
              class="bg bannrImgAnimation"
              :style="{ backgroundImage: 'url(' + Pcbg(item) + ')' }"
            ></div>
            <div class="banner_cont">
              <img class="bg0 descAnimation delay-1" :src="item.logo" alt="" />
              <div class="banenr_txt">
                <div class="name descAnimation delay-2">{{ item.title }}</div>
                <div v-if="item.desc != ''" class="desc descAnimation delay-2">
                  {{ item.desc }}
                </div>
                <div class="btn_warp descAnimation delay-3">
                  <a
                    class="more haClass"
                    :href="item.jump_link"
                    target="_blank"
                    >{{ item.btn_text }}</a
                  >
                </div>
              </div>
            </div>
            <!-- 遮罩 -->
            <div
              class="mask"
              :style="{
                backgroundImage:
                  'linear-gradient(to top, ' +
                  item.bg_color +
                  ', ' +
                  item.bg_color +
                  ' 20%, transparent 100%)',
              }"
            ></div>
          </div>
        </div>
      </div>

      <!-- 分页 -->
      <div
        class="swiper-pagination"
        :class="isStop ? 'stop' : ''"
        id="custom"
      ></div>
      <!-- 左右切换 -->
      <div class="prevCont">
        <!-- 如果需要导航按钮 -->
        <div class="swiper-button-prev sprev"></div>
        <div class="swiper-button-next snext"></div>
      </div>
    </div>
  </div>
</template>
<script>
import Swiper from "swiper";
export default {
  name: "Banner",
  props: ["BnnerSlides"],
  data() {
    return {
      screenWidth: document.body.clientWidth,
      isStop: false, //是否停止动画
      s1: "", //banner
    };
  },
  created() {},
  mounted() {
    let that = this;
    window.onresize = () => {
      return (() => {
        window.screenWidth = document.body.clientWidth;
        that.screenWidth = window.screenWidth;
        that.s1.init();
      })();
    };
  },
  computed: {},
  methods: {
    Pcbg(item) {
      if (this.screenWidth < 769) {
        return item.mobile_bg;
      } else {
        return item.pc_bg;
      }
    },
    sw() {
      let that = this;
      this.$nextTick(function () {
        that.s1 = new Swiper("#s1", {
          autoplay: {
            delay: 4000,
            stopOnLastSlide: false,
            disableOnInteraction: false,
          },
          loop: true,
          pagination: {
            el: ".swiper-pagination",
            clickable: true,
            renderBullet: function (index, className) {
              return '<span class="sItem ' + className + '"></span>';
            },
          },
          navigation: {
            nextEl: ".prevCont .snext", //自动隐藏
            prevEl: ".prevCont .sprev", //自动隐藏
            hiddenClass: "btn-hidden", //某些情况下需要隐藏前进后退按钮时，可以设定一个自定义的类名。
          },
        });
        that.s1.el.onmouseover = function () {
          //鼠标放上暂停轮播
          that.s1.autoplay.stop();
          that.isStop = true;
        };
        that.s1.el.onmouseleave = function () {
          that.s1.autoplay.start();
          that.isStop = false;
        };
      });
    },
  },
  watch: {
    //监听有值之后初始化轮播
    BnnerSlides() {
      this.sw();
    },
  },
};
</script>
<style scoped>
/*banner*/

.swiper-pagination {
  height: 26px;
  margin-top: -26px;
  width: 100%;
  transition: 300ms opacity;
  transform: translate3d(0, 0, 0);
  display: flex;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  position: relative;
  z-index: 999;
}

.prevCont > div {
  opacity: 0;
  transition: all 0.3s;
}
.banner:hover .prevCont > div {
  opacity: 1;
  transition: all 0.3s;
}
</style>


// WEBPACK FOOTER //
// src/components/Banner.vue